import {Coupon} from './Coupon';
import {DotItem} from './DotItem';
import {OrderItem} from './OrderItem';
import {ReviewItem} from './ReviewItem';
import {ProfileItem} from './ProfileItem';
import {CarouselItem} from './CarouselItem';
import {CategoryItem} from './CategoryItem';
import {WishlistItem} from './WishlistItem';
import {PromocodeItem} from './PromocodeItem';

export const items = {
  Coupon,
  DotItem,
  OrderItem,
  ReviewItem,
  ProfileItem,
  CategoryItem,
  WishlistItem,
  CarouselItem,
  PromocodeItem,
};
